import * as React from "react";
const SvgLogout = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={16}
    fill="none"
    {...props}
  >
    <path
      stroke="#2D2D2D"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.11}
      d="M2.431 4.363a6.413 6.413 0 0 0 0 9.066 6.413 6.413 0 0 0 9.066 0 6.413 6.413 0 0 0 0-9.066M6.964 7.989V.555"
    />
  </svg>
);
export default SvgLogout;
